export default __webpack_public_path__ + "static/media/disconnect.07f47320.png";